import { Pipe, PipeTransform } from "@angular/core";
import { moment } from "shared/cubiq-model-multi-asset";

@Pipe({
  name: "bfxMoment",
  standalone: false,
})
export class BfxMomentPipe implements PipeTransform {
  transform(value: number, format: string): string {
    if (!isNaN(value) && value > 0) {
      return moment(value).format(format);
    }
    return "";
  }
}
